<tt-page *ngIf="!!page">
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="editTable"></ng-container>
        </tt-card>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card *ngIf="p2TableKeyno === '0'" ttHeading="h_p2table_new">
            <ng-container *ngTemplateOutlet="editTable"></ng-container>
        </tt-card>

        <tt-card *ngIf="p2TableKeyno !== '0'" ttHeading="h_p2table_edit">
            <ng-container *ngTemplateOutlet="editTable"></ng-container>
        </tt-card>
    </ng-container>
</tt-page>

<ng-template #editTable>
    <ng-container *ngIf="!!page">
        <tt-input ttLabel="p2_table_keyno" [ttModel]="page.p2_table_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="table_name" [(ttModel)]="page.table_name" ttRequired></tt-input>
        <tt-input ttLabel="word_id" [(ttModel)]="page.word_id" ttRequired></tt-input>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button-goto ttText="p2_webpage_table_from_table" ttGoto="p2webpagetable" [ttGotoParms]="{ argtype: 'p2_table_keyno', argvalue: page.p2_table_keyno }">
        </tt-button-goto>
    </ng-container>
</ng-template>
